module.exports = { "default": require("core-js/library/fn/symbol"), __esModule: true };


//////////////////
// WEBPACK FOOTER
// ./~/react-share/~/babel-runtime/core-js/symbol.js
// module id = 557
// module chunks = 0